<script>
  import { createEventDispatcher } from 'svelte';

  export let owner;
  export let metadata;

  const dispatch = createEventDispatcher()

</script>

<div class="container" on:click={event => dispatch("click", event)}>
  <h3>{metadata?.name || ""}</h3>
  
  <h4>{metadata?.methods?.__call__ && metadata?.methods?.__call__[0]}</h4>
  <p>by: <span style={owner === 'you' ? "color: var(--primary);":""}>{owner == 'you' ? owner: "ephemeral_"+ owner}</span></p>
</div>


<style>
  .container {
    border-color: var(--foreground);
    border-style: solid;
    border-width: 0.5px;
    border-radius: 10px;
    width: 390px;
    cursor: pointer ;
  }
</style>